export const SET_PAYLOAD = "SET_PAYLOAD";
export const setPayload = (data) => ({
  type: SET_PAYLOAD,
  data: data,
});
